import React, {useState} from 'react';
import {connect, DispatchProp} from "react-redux";
import {withTranslation} from "react-i18next";
import {ReactComponent as UserIco} from "../../../images/icons/user-circle.svg";
import {RootState} from "../../../reducers";
import {getUser} from "../../services/User/reducer";
import {getStoreConfigLoyalty} from "../../services/Store/reducer";
import LoginUserModal from "../User/LoginUserModal";
import UserUtils from "../../services/User/UserUtils";
import UserDrawer from "./UserDrawer/UserDrawer";


type Props = ReturnType<typeof mapStateToProps> & DispatchProp;

function NavbarUser(props: Props) {
    const {user} = props;
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [showUserDrawer, setShowUserDrawer] = useState(false);

    if (!UserUtils.isLoyaltyEnabled(props.config_loyalty)) return null;

    const showDrawer = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        setShowUserDrawer(true);
        event.currentTarget.blur();
    }

    const handleUserButtonClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if(user && user.name) {
            showDrawer(event);
        }
        else {
            setShowLoginModal(true);
            event.currentTarget.blur();
        }
    }

    return (
        <>
            {user.pending ? (
                <>
                    <button className={"btn btn-icon btn-spinner loading"} onClick={showDrawer}>
                        <span className="left spinner-border spinner-border-sm"/>
                    </button>
                </>
            ) : (
                <>
                    <button className={"btn btn-icon"} onClick={handleUserButtonClick}>
                        <UserIco/>
                    </button>
                    {showLoginModal && (
                        <LoginUserModal onHide={() => setShowLoginModal(false)} show/>
                    )}
                    {showUserDrawer && (
                        <UserDrawer onHide={() => setShowUserDrawer(false)} show/>
                    )}
                </>
            )}
        </>
    )
}

const mapStateToProps = (state: RootState) => ({
    user: getUser(state.user),
    config_loyalty: getStoreConfigLoyalty(state.config)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(NavbarUser));